import styled from "styled-components";
import StyledText from "../../atoms/Text/Text.styled";

const StyledPrincipalID = styled(StyledText)`
  color: ${({ theme }) => theme.palette.primary};
`;

export default StyledPrincipalID;
